import React from 'react';
import { MapPinIcon } from 'lucide-react';
export function CitiesGrid() {
  const cities = ['חולון', 'בת ים', 'אזור', 'ראשון לציון', 'תל אביב-יפו', 'גבעתיים', 'רמת גן', 'אור יהודה', 'קריית אונו', 'יהוד-מונוסון', 'בני ברק', 'נס ציונה', 'רחובות', 'פתח תקווה', 'לוד', 'רמלה'];
  return <section className="py-16 bg-white px-4 md:px-8 border-t border-gray-100" data-id="element-26">
      <div className="max-w-6xl mx-auto text-center" data-id="element-27">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-28">
          אנחנו נותנים שירות באזור המרכז
        </h2>
        <p className="text-xl text-gray-600 mb-10 font-medium" data-id="element-29">
          <a href="tel:0523552222" className="text-[#f97316] hover:underline" data-id="element-30">
            052-355-2222
          </a>
          {' | '}
          <a href="tel:0545188888" className="text-[#f97316] hover:underline" data-id="element-31">
            054-518-8888
          </a>{' '}
          – זמינים בכל מקום, מגיעים מהר
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-6 gap-3 md:gap-4 mb-10" data-id="element-32">
          {cities.map((city, index) => <div key={index} className="flex items-center justify-center gap-2 border border-gray-200 rounded-full px-3 py-2 text-sm text-gray-600 hover:border-[#f97316] hover:text-[#f97316] transition-colors cursor-default bg-gray-50" data-id="element-33">
              <MapPinIcon className="w-3 h-3" data-id="element-34" />
              {city}
            </div>)}
        </div>

        <p className="text-lg text-gray-500" data-id="element-35">
          לא רואים את העיר שלכם?{' '}
          <a href="tel:0523552222" className="text-[#f97316] font-bold hover:underline" data-id="element-36">
            התקשרו ונבדוק: 052-355-2222 | 054-518-8888
          </a>
        </p>
      </div>
    </section>;
}